import styled from 'styled-components'

export const FormWrapper = styled.div`
  max-width: 820px;
  margin: 0 auto;
  padding: 28px 16px;
`;

export const FormCard = styled.div`
  background: ${({ theme }) => theme.card || '#071025'};
  color: ${({ theme }) => theme.text};
  padding: 28px;
  border-radius: 14px;
  box-shadow: 0 12px 40px rgba(2,6,23,0.6);
  border: 1px solid rgba(255,255,255,0.03);
`;

export const FormHeader = styled.div`
  display:flex;
  align-items:center;
  justify-content:space-between;
  margin-bottom: 16px;

  h1{ margin: 0; font-size: 1.4rem; letter-spacing: -0.01em; }
`;

export const StyledForm = styled.form`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px 16px;
  align-items: start;
  box-sizing: border-box;

  > div { min-width: 0; }

  @media (max-width: 720px) {
    grid-template-columns: 1fr;
  }
`;

export const Label = styled.label`
  display:block;
  font-size: 0.75rem;
  color: rgba(255,255,255,0.75);
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin-bottom: 6px;
`;

export const Input = styled.input`
  width:100%;
  box-sizing: border-box;
  padding: 12px 14px;
  border-radius: 10px;
  border: 1px solid ${({ theme }) => theme.inputBorder || 'rgba(255,255,255,0.06)'};
  background: ${({ theme }) => theme.inputBackground || 'transparent'};
  color: inherit;
  font-size: 0.98rem;
  outline: none;
  transition: box-shadow .12s ease, border-color .12s ease;

  &:focus{
    box-shadow: 0 8px 24px rgba(0,0,0,0.35);
    border-color: ${({ theme }) => theme.accent || 'rgba(175,127,255,0.28)'};
  }
`;

export const Textarea = styled.textarea`
  grid-column: 1 / -1;
  width:100%;
  box-sizing: border-box;
  padding: 12px 14px;
  border-radius: 10px;
  border: 1px solid ${({ theme }) => theme.inputBorder || 'rgba(255,255,255,0.06)'};
  background: ${({ theme }) => theme.inputBackground || 'transparent'};
  color: inherit;
  font-size: 0.98rem;
  min-height: 160px;
  resize: vertical;
  outline: none;
  transition: box-shadow .12s ease, border-color .12s ease;

  &:focus{
    box-shadow: 0 8px 24px rgba(0,0,0,0.35);
    border-color: ${({ theme }) => theme.accent || 'rgba(175,127,255,0.28)'};
  }
`;

export const SubmitButton = styled.input`
  grid-column: 1 / -1;
  justify-self: start;
  cursor: pointer;
  padding: 12px 20px;
  border-radius: 10px;
  border: 0;
  background: ${({ theme }) => theme.buttonGradient || 'linear-gradient(90deg,#ff8a00,#e52e71)'};
  color: white;
  font-weight: 700;
  font-size: 1rem;
  margin-top: 6px;
  box-shadow: 0 10px 30px rgba(229,46,113,0.18);
  transition: transform .12s ease, box-shadow .12s ease, opacity .12s ease;

  &:hover{ transform: translateY(-2px); box-shadow: 0 14px 36px rgba(229,46,113,0.22); }
`;

export const AlertWrapper = styled.div`
  margin-bottom: 12px;
`;

const ContactFormStyles = {
  FormWrapper,
  FormCard,
  FormHeader,
  StyledForm,
  Label,
  Input,
  Textarea,
  SubmitButton,
  AlertWrapper,
};

export default ContactFormStyles;
